import Big from 'big.js';
import rfdc, { type Options } from 'rfdc';

// Date, Map, and Set are included automatically by rfdc
const constructorHandlers: Options['constructorHandlers'] = [
  [RegExp, (o) => new RegExp(o)],
  [Big, (o) => new Big(o)],
  [WeakMap, (o) => new WeakMap(o)],
  [WeakSet, (o) => new WeakSet(o)],
];

export const clone = rfdc({ proto: false, constructorHandlers });

export const cloneCircular = rfdc({
  circles: true,
  proto: false,
  constructorHandlers,
});

// export const cloneCircularWithProto
